var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card-group',[_c('transition-group',{attrs:{"name":"entry-card-group","tag":"div"}},_vm._l((_vm.entries),function(entry){return _c('EntryCard',{key:entry.entryId,attrs:{"entry":entry}})}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }